import { AnyEntity } from "@mapmycustomers/shared/types/entity";
import User from "@mapmycustomers/shared/types/User";
import { isDefined } from "@mapmycustomers/shared/util/assert";

import ReportType from "@app/enum/ReportType";

import MapFilter from "../../enums/MapFilter";

import { getExportTypeByReportTypeAndMapFilter } from "./ExportType";
import formatUserTeamsById from "./formatUserTemsById";
import getDataRowFromEntity from "./getDataRowFromEntity";
import getHeaderRow from "./getHeaderRow";

const downloadEntitiesAsCsv = (
  entities: AnyEntity[],
  reportType: ReportType,
  filter: MapFilter,
  users?: User[]
) => {
  if (!entities.length) {
    return; // nothing to export
  }
  const userTeamsById = formatUserTeamsById(users);

  const exportType = getExportTypeByReportTypeAndMapFilter(reportType, filter);

  const dataRows = entities
    .map((entity) => getDataRowFromEntity(exportType, entity, userTeamsById))
    .filter(isDefined);
  const headerRow = getHeaderRow(exportType);
  const csvText = [headerRow.join(","), ...dataRows.map((row) => row.join(","))].join("\n");

  const blob = new Blob([csvText], { type: "text/plain" });
  const fileName = `${reportType}_${filter ? filter : ""}.csv`;

  const hiddenElement = window.document.createElement("a");
  hiddenElement.href = window.URL.createObjectURL(blob);
  hiddenElement.download = fileName;
  document.body.appendChild(hiddenElement);
  hiddenElement.click();
  document.body.removeChild(hiddenElement);
};

export default downloadEntitiesAsCsv;
